import { prefixObjectValues } from '../utils';

const requestForm = {
  form: 'form',
  firstName: 'firstName',
  lastName: 'lastName',
  emailAddress: 'emailAddress',
  phoneNumber: 'phoneNumber',
  relationshipType: 'relationshipType',
  submitBtn: '-submit-button',
  closeBtn: '-close-button',
};

export default prefixObjectValues(requestForm, 'peer-reference-request-form');
